"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getShouldSkipProductsQuery = exports.getLabelValidationFilter = exports.getLockedProductsFilter = void 0;
const getLockedProductsFilter = (shouldFetchLockedCount, filter) => {
    if (!shouldFetchLockedCount)
        return undefined;
    return Object.assign(Object.assign({}, filter), { product: Object.assign(Object.assign({}, filter === null || filter === void 0 ? void 0 : filter.product), { isLocked: { equals: true } }) });
};
exports.getLockedProductsFilter = getLockedProductsFilter;
const getLabelValidationFilter = (productTextAttributesFilter, skipLabelValidation) => {
    var _a;
    if (skipLabelValidation || !productTextAttributesFilter)
        return undefined;
    return {
        some: {
            label: (_a = productTextAttributesFilter[0]) === null || _a === void 0 ? void 0 : _a.label,
        },
    };
};
exports.getLabelValidationFilter = getLabelValidationFilter;
const getShouldSkipProductsQuery = (catalogId, productTreeNodeId, productTreeId, shouldSkip) => !catalogId || !productTreeNodeId || !productTreeId || !!shouldSkip;
exports.getShouldSkipProductsQuery = getShouldSkipProductsQuery;
